/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BasePOCOMongoEntity } from './basePOCOMongoEntity';
import { EntityStatus } from './entityStatus';


export interface MapRelayContentToServiceModel extends BasePOCOMongoEntity { 
    id: string | number;
    returnId?: string;
    serviceId?: string;
    partnerId: number;
    serviceProviderId: number;
    relayContentId: number;
    serviceShortCode?: string;
    contentPartnerName?: string;
    keyword?: string;
}
